import './index.scss'
$("#nav2").addClass('active')